import React from 'react'

import SubscribeContext from 'contexts/SubscribeContext'

const useSubscribe = () => {
  const context = React.useContext(SubscribeContext)

  if (context === undefined) {
    throw new Error(
      'useSubscribe must be used within a SubscribeContext.Provider',
    )
  }

  const forceLogin = React.useCallback(() => {
    context.setActiveStep(1)
    context.setRequireLogin(true)
  }, [context])

  const addItemCart = React.useCallback(
    // cria outra referência para o item, para poder ser removido por referência
    item => context.setCart(cart => [...cart, { ...item }]),
    [context],
  )

  const removeItemCart = React.useCallback(
    removedItem =>
      context.setCart(cart => cart.filter(item => removedItem !== item)),
    [context],
  )

  const clearCart = React.useCallback(() => context.setCart([]), [context])

  const sizeCart = React.useMemo(() => context.cart.length, [context.cart])

  const totalCart = React.useMemo(
    () =>
      context.cart.reduce((total, item) => total + parseFloat(item.price), 0),
    [context.cart],
  )

  const nextStep = React.useCallback(
    () => context.setActiveStep(prevActiveStep => prevActiveStep + 1),
    [context],
  )

  const backStep = React.useCallback(
    () => context.setActiveStep(prevActiveStep => prevActiveStep - 1),
    [context],
  )

  return React.useMemo(
    () => ({
      ...context,
      forceLogin,
      sizeCart,
      totalCart,
      addItemCart,
      removeItemCart,
      clearCart,
      nextStep,
      backStep,
    }),
    [
      context,
      forceLogin,
      sizeCart,
      totalCart,
      addItemCart,
      removeItemCart,
      clearCart,
      nextStep,
      backStep,
    ],
  )
}

export default useSubscribe
